import Vue from 'vue'
import App from './App.vue'

import Framework7 from 'framework7/framework7-lite.esm.bundle.js'; // Import F7 Bundle
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js'; // Import F7-Vue Plugin Bundle (with all F7 components registered)

import ApiService from './services/api-main';
import TokenService from './services/token-service';

import { i18n } from './plugins/i18n';
import underscore from './plugins/underscore';
import mixin from './plugins/mixin';
import SessionModal from './plugins/session-plugin';
import idleVue from './plugins/idle-vue';
import moment from './plugins/moment';

import store from './store';


Vue.config.productionTip = false;
Framework7.use(Framework7Vue)
Vue.use(underscore)
Vue.use(mixin)
Vue.use(SessionModal)
Vue.use(idleVue)
Vue.use(moment)

ApiService.init()

// If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeader()
}

console.log("mode: " + process.env.VUE_APP_MODE)

export default new Vue({
  // Root Element
  el: '#app',
  i18n,
  store,
  mounted() {
    if (window.Android || window.webkit) {
      // Push Notification redirects to specific page
      window.navigatePushNotificationTo = (path) => {
        this.navigateToPath(path);
      }

      window.registerPushNotification = (token, uuid, carrier) => {
        this.registerPushNotification(token, uuid, carrier);
      }

      window.getBiometryType = (type) => {
        this.$emit("handleBiometryType", type);
      }

      window.getVersionApplication = (version) => {
        // DR-1931: cache the native build version so the MyInfo/SingPass authorise calls can forward it
        // (used by the WS to route App-Links-capable builds to the v5 account).
        ApiService.saveFormData("appVersion", version);
        this.$emit("retrieveVersionApp", version);
      }

      window.sendBiometryToken = (token) => {
        this.validateBiometryToken(token);
      }

      window.proceedMyInfoMobileCallback = (isUserCancel, state, code) => {
        this.$emit("proceedMyInfoMobileCallback", isUserCancel, state, code);
      }

      window.setAppleSignIn = (method, token) => {
        if (token == 'EMPTY') {
          this.hidePreloader();
          this.appleSignIn(method, true);
        } else if (method == 1 && token != '') { // Login
          this.appleSignInResponse(method, token);
        } else if (method == 2 && token != '') { // Register
          this.appleSignUpResponse(token);
        } else if ((method == 3 || method == 4) && token != '') { // Refresh Session or Edit Email or Edit Mobile Number
          this.$emit("handleApleValidationStatus", token);
          this.closePopupOnMobile();
        } else {
          this.hidePreloader();
        }
      }

      if (window.Android) {
        window.Android.getWandrCallback(JSON.stringify({ "type": 'webapp_ready' }));
      } else if (window.webkit) {
        window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": 'webapp_ready' }));
      }

      // DR-1931: request the native build version early so it is cached before any MyInfo/SingPass authorise call.
      this.getVersionApp();

      if (!this.isMyInfoUseInAppBrowser()) {
        let title;
        let textButton;
        if (window.Android) {
          title = this.$t('update-app-version-android')
          textButton = this.$t('update-app-button-android')
        } else {
          title = this.$t('update-app-version')
          textButton = this.$t('update-app-button')
        }
        const forceUpdatePopup = this.$f7.dialog.create({
          title: 'Wandr-E',
          text: title,
          buttons: [{
            text: textButton, close: false, onClick: function () {
              if (window.Android) {
                window.Android.getWandrCallback(JSON.stringify({ "type": 'open_page', 'data': 'https://play.google.com/store/apps/details?id=com.wandr.app' }));
              } else if (window.webkit) {
                window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": 'open_page', 'data': 'https://apps.apple.com/us/app/wandr-e/id6446774264' }));
              }
            }
          }]
        });
        forceUpdatePopup.open();
      }
    }

    // Initialize Apple Sign In
    window.initAppleAccount = () => {
      if (window.AppleID) {
        window.AppleID.auth.init({
          clientId: process.env.VUE_APP_APPLE_CLIENT_ID,
          scope: "name email",
          redirectURI: process.env.VUE_APP_APPLE_REDIRECT_URI,
          state: new Date().getTime().toString(),
          usePopup: true
        });
      }
    }

    // Initialize Google Sign In
    window.initGoogleAccount = () => {
      Vue.prototype.$googleAuth = window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        scope: 'https://www.googleapis.com/auth/userinfo.email',
        callback: this.googleSignInResponse
      });
    }

    window.$zoho.salesiq.afterReady = function () {
      const query = window.location.href.split('?');
      if (query.length > 1) {
        const params = new URLSearchParams(query[1]);
        console.log("WEB Params: ", params.get('csZoho'));
        if (params.get('csZoho') != null) {
          setTimeout(() => {
            const data = JSON.stringify({ "type": "open_zoho_chat", 'cs_zoho': params.get('csZoho') });
            if (window.Android) {
              window.Android.getWandrCallback(data);
            } else if (window.webkit) {
              window.webkit.messageHandlers.WandrCallbackHandler.postMessage(data);
            } else {
              window.$zoho.salesiq.visitor.question(params.get('csZoho'));
              window.$zoho.salesiq.chat.start();
              window.$zoho.salesiq.floatwindow.visible('show');
            }
          }, 3000)
        }
      }

      if(store.state.registration.isAxsr) {
        window.$zoho.salesiq.chatbutton.visible("show");
        window.$zoho.salesiq.floatbutton.visible("show");
      }

      this.setZohoChatbotCustomer();
    }
  },
  onIdle() {
    console.log('idle')
  },
  onActive() {
    console.log('active')
    this.checkTokenExpiry()
  },
  render: c => c(App),
});